import routes from 'App/routeConstants';
import { store } from 'App/store';
import { HOME_FOLD_NAME, TRASH_FOLD_NAME } from '../consts';
import _ from 'lodash';

export function filterStringFromUrlChars(folderName) {
  return folderName.replace(/[\/%]/g, '');
}

export function getFolderUrl(folderName) {
  return `${routes.MyAccount.ViewTemplatesBase}/${encodeURIComponent(filterStringFromUrlChars(folderName))}`;
}

export function getFolderIdByName(name) {
  const folders = store.getState().user.tags;
  switch (name) {
    case undefined:
    case HOME_FOLD_NAME:
      return '0';
    case TRASH_FOLD_NAME:
      return '1';
    default: {
      let id = -1;
      for (const i in folders) {
        if (folders && folders[i] === decodeURI(name)) {
          id = i;
        }
      }
      if (id !== -1) {
        return `${id}`;
      }
      return '0';
    }
  }
}
